<footer
id="cx-footer"
cxSkipLink="cx-footer">
<app-compare-products></app-compare-products>
    <div class="footer">       
        <div class="footer-content">
            <cx-page-slot position="Footer"></cx-page-slot>
        </div>

    </div>
    <div class="bottom-footer">
        <cx-page-slot position="FooterBottom"></cx-page-slot>
        
    </div>
   
</footer>